import { render } from "./iconLogo.vue?vue&type=template&id=5ab0529c&scoped=true"
import script from "./iconLogo.vue?vue&type=script&lang=js"
export * from "./iconLogo.vue?vue&type=script&lang=js"

import "./iconLogo.vue?vue&type=style&index=0&id=5ab0529c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ab0529c"

export default script